<script lang="ts">
// use normal <script> to declare options
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";

const props = defineProps({
  back: {
    type: Boolean,
    default: false,
  },
  backIcon: {
    type: String,
    default: "arrow_left",
  },
});

const emit = defineEmits(["hide", "backClick"]);

function hideModal() {
  emit("hide");
}

function onBackClick() {
  emit("backClick");
}

function keyEscPress(e: KeyboardEvent) {
  if (e.key === "Escape") {
    hideModal();
  }
}

onMounted(() => {
  document.addEventListener("keyup", keyEscPress);
});

onUnmounted(() => {
  document.removeEventListener("keyup", keyEscPress);
});
</script>

<template>
  <div class="center_modal_main" @click.self="hideModal">
    <div class="center_card" v-bind="$attrs">
      <button
        v-if="props.back || $slots.back"
        type="button"
        class="center_modal_back_button_container"
        @click.stop="onBackClick"
      >
        <slot v-if="$slots.back" name="back"></slot>
        <SvgIcon v-else :name="props.backIcon" class="center_modal_back_button" />
      </button>
      <slot name="body"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";
@use "assets/scss/modal";

.center_card {
  background-color: var(--white-main);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
}

.center_modal_back_button_container {
  @apply flex items-center justify-center;
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
  width: 40px;
  height: 40px;
  border-radius: 16px;
  color: var(--text-secondary-color);

  &:hover {
    background: var(--grey-light);
    color: var(--text-main-color);
  }
}

.center_modal_back_button {
  @apply max-h-[24px] max-w-[24px] h-full w-full;
}

@media (max-width: 768px) {
  .center_card {
    &[data-responsive="true"] {
      max-height: 100% !important;
      max-width: 100% !important;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transform: translate(0, 0);
      border-radius: 0;
    }
  }
}

.center_modal_main {
  @apply background_modal__grey;
  z-index: 501;
}
</style>
